import { render, staticRenderFns } from "./AddGearItem.vue?vue&type=template&id=a999dc8a"
import script from "./AddGearItem.vue?vue&type=script&lang=js"
export * from "./AddGearItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports